import React from 'react';
import LineupCamIcon from 'components/Icons/LineupCamIcon';

import styles from './LineupCamBadge.module.scss';

const LineupCamBadge = () => (
  <div className={styles.badge} data-testid="lineup-cam-badge">
    <LineupCamIcon />
  </div>
);

LineupCamBadge.displayName = 'LineupCamBadge';

export default React.memo(LineupCamBadge);
